import ArticleLink from '@/components/feature/ArticleLink';
import { basicsCards } from '@/mocks/home';
import ScrollReveal from '@/components/base/ScrollReveal';
import SectionHeading from '@/components/base/SectionHeading';

const basicsTips = [
  { icon: 'ri-book-2-line', label: '6 บทความ' },
  { icon: 'ri-time-line', label: 'รวม 29 นาที' },
];

export default function BasicsGrid() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20 lg:px-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="พื้นฐานที่ต้องรู้"
            title="Forex พื้นฐานที่มือใหม่ควรรู้"
            subtitle="เริ่มต้นจากความเข้าใจพื้นฐานก่อนเรียนรู้การเทรด Forex ทุกบทความอธิบายด้วยภาษาง่าย ๆ ใช้เวลาอ่านสั้น ๆ"
          />
          <ArticleLink
            to="/forex-basics"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            ดูพื้นฐานทั้งหมด
            <i className="ri-arrow-right-line text-base" />
          </ArticleLink>
        </div>

        <div className="mt-12 grid auto-rows-fr grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {basicsCards.map((card, index) => (
            <ScrollReveal key={card.index} delay={index * 70} className="h-full">
              <ArticleLink
                to={card.slug}
                className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
              >
                <span className="absolute right-5 top-4 font-num text-4xl font-semibold text-background-200 transition-colors group-hover:text-primary-200">
                  {card.index}
                </span>

                <h3 className="font-heading text-lg font-semibold text-foreground-950">{card.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{card.desc}</p>

                <ul className="mt-4 flex flex-1 flex-col gap-2">
                  {card.points.map((point) => (
                    <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line mt-0.5 text-sm text-accent-600" />
                      <span className="leading-relaxed">{point}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-6 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="flex items-center gap-1.5 text-xs font-medium text-foreground-600">
                    <i className="ri-time-line text-sm" />
                    อ่าน {card.minutes} นาที
                  </span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line text-base" />
                  </span>
                </div>
              </ArticleLink>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal delay={120}>
          <div className="mt-10 flex flex-col items-start gap-4 rounded-2xl border border-background-200 bg-background-100/60 p-6 sm:flex-row sm:items-center sm:gap-5 md:p-7">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-lightbulb-line text-xl" />
            </span>
            <div className="flex-1">
              <h3 className="font-heading text-base font-semibold text-foreground-950">
                เรียนตามลำดับ จะเข้าใจเร็วขึ้น
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                เริ่มจาก «Forex คืออะไร?» แล้วไล่ไปทีละบท เมื่อจบครบทุกบท คุณจะพร้อมสำหรับการเทรดจริง
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-foreground-700">
              {basicsTips.map((tip) => (
                <span key={tip.label} className="flex items-center gap-1.5 whitespace-nowrap">
                  <i className={`${tip.icon} text-base text-accent-600`} />
                  {tip.label}
                </span>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}